import React from 'react'

const ProjectsHeader = () => {
    return (
        <div className='ProjectsHeader'>
            <h1 className='Projects-title wow fadeInDown'>Projects</h1>
        </div>
    )
}

export default ProjectsHeader
